import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { DateValidation, RangeValidation } from '../../validators/dateValidation'
import { AgGridAngular } from 'ag-grid-angular';
import { localeSwedish } from '../locale.swedish';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { SPINNER_ANIMATIONS, SPINNER_PLACEMENT, ISpinnerConfig, NgxSpinner } from '@hardpool/ngx-spinner';
import { ExcelReportWriterHelper } from '../../helpers/excelReportWriterHelper';
import { InvoiceReport } from '../../model/report/invoiceReport';
import { ColDef, GridOptions } from 'ag-grid-community';
import { ReportService } from '../../services/report.service';

@Component({
  selector: 'invoices',
  templateUrl: 'invoices.component.html',
  styleUrls: ['invoices.component.css'],
})
export class InvoicesComponent implements OnInit {

  @ViewChild('agGrid', { static: true }) agGrid: AgGridAngular;
  @ViewChild("spinner", { static: true }) spinner: NgxSpinner;

  searchForm: UntypedFormGroup;
  dateGroup: UntypedFormGroup;
  busy: boolean = false;
  spinnerConfig: ISpinnerConfig;

  maxDate: Date = new Date();

  fromDateControl: UntypedFormControl;
  toDateControl: UntypedFormControl;

  columnDefs : ColDef[]  = [
    { headerName: 'Flightnr', field: 'flightNumber', width: 105, sortingOrder: ["asc", "desc"] },
    { headerName: 'Typ', field: 'flightType', width: 115, sortingOrder: ["asc", "desc"] },
    { headerName: 'Operatör', field: 'operator', width: 100, sortingOrder: ["asc", "desc"] },
    { headerName: 'Regnr', field: 'aircraftRegistration', width: 120, sortingOrder: ["asc", "desc"] },
    { headerName: 'FTyp', field: 'aircraftType', width: 115, sortingOrder: ["asc", "desc"] },
    { headerName: 'DI', field: 'diIndicator', width: 125, sortingOrder: ["asc", "desc"] },
    { headerName: 'Dest.', field: 'destination', width: 105, sortingOrder: ["asc", "desc"] },
    { headerName: 'Term', field: 'terminal', width: 115, sortingOrder: ["asc", "desc"] },
    { headerName: 'Stand', field: 'stand', width: 105, sortingOrder: ["asc", "desc"] },
    { headerName: 'Gate', field: 'gate', width: 105, sortingOrder: ["asc", "desc"] },
    {
      headerName: 'Sched', field: 'scheduledTime', width: 105, sortingOrder: ["asc", "desc"], cellRenderer: (result) => {
        return result.data.scheduledTime ? moment(result.data.scheduledTime).format('YYYY-MM-DD HH:mm') : ""
      }
    },
    {
      headerName: 'Block', field: 'blockTime', width: 90, sortingOrder: ["asc", "desc"], cellRenderer: (result) => {
        return result.data.blockTime ? moment(result.data.blockTime).format('YYYY-MM-DD HH:mm') : ""
      }
    },
    { headerName: 'Pax', field: 'numberOfPax', width: 90, sortingOrder: ["asc", "desc"] },
    { headerName: 'Bussnr', field: 'busNumber', width: 90, sortingOrder: ["asc", "desc"] },
    { headerName: 'Chf', field: 'driver', width: 90, sortingOrder: ["asc", "desc"] },
    {
      headerName: 'Fakt', field: 'isInvoiced', width: 90, sortingOrder: ["asc", "desc"], cellRenderer: (result) => {
        return result.data.isInvoiced ? "Ja" : "Nej";
      }
    },
    { headerName: 'Handl', field: 'handlers', width: 90, sortingOrder: ["asc", "desc"] },
    { headerName: 'Kom', field: 'comment', width: 90, sortingOrder: ["asc", "desc"] }

  ];
  public gridOptions: GridOptions = {
    columnDefs: this.columnDefs,
    paginationPageSize: 13,
    pagination: true,
    animateRows: true
  }
  localeText = {};
  invoiceRowData = [];

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly toaster: ToastrService,
    private readonly reportService: ReportService) {

    this.fromDateControl = new UntypedFormControl([Validators.required, DateValidation()]);
    this.toDateControl = new UntypedFormControl([Validators.required, DateValidation()]);

    this.localeText = localeSwedish;

    this.dateGroup = this.fb.group({
      from: this.fromDateControl,
      to: this.toDateControl,
    },
      {
        validator: RangeValidation()
      });

    this.searchForm = this.fb.group(
      {
        date: this.dateGroup
      });
  }

  ngOnInit() {
    this.spinnerConfig = {
      placement: SPINNER_PLACEMENT.block_ui,
      animation: SPINNER_ANIMATIONS.horizontal_bounce,
      size: "2rem",
      color: "#7AB800",
      bgColor: "rgba(255,255,255,1)"
    };
  }

  canSearch() {
    return this.searchForm.valid && !this.busy;
  }

  exportReport() {
    ExcelReportWriterHelper.exportInvoiceReport(
      this.invoiceRowData,
      this.fromDateControl.value,
      this.toDateControl.value)
  }

  canExport() {
    return this.invoiceRowData.length > 0;
  }

  async search() {
    if (this.searchForm.valid) {
      this.spinner.show();
      let from = new Date(this.fromDateControl.value);
      let to = new Date(this.toDateControl.value);
      let rows = [];
      this.busy = true;
      try {
        let response: InvoiceReport = await this.reportService.getInvoicesReportDb(from.toDateString(), to.toDateString())
        this.spinner.hide();
        if (response.invoices) {
          response.invoices.forEach(invoice => {
            rows.push(invoice);
          });
        }

        this.busy = false;
        this.invoiceRowData = rows;
      }
      catch (error) {
        this.busy = false;
        this.spinner.hide();
        this.showError("Ett fel uppstod vid inläsning av data.")
      }
    }
  }

  showError(message: string) {
    this.toaster.error(message);
  }

}
